export default __webpack_public_path__ + "static/media/ENLACANCHA-Logo-Largo.f67fb09e.png";